import React from 'react'
import LoginContainers from 'containers/Login'
const Login = () => {
    return (
       
        <LoginContainers />
        
    )
}

export default Login
